
export default (value = "", suffix = "") => camelCase(`${value} ${suffix}`.trim());

const camelCase = str => str.toLowerCase().replace(/[^a-zA-Z0-9]+(.)/g, (m, chr) => chr.toUpperCase());